var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
export function LoadingBackdrop(props) {
    return (_jsx(Backdrop, __assign({ open: true, sx: { zIndex: 99999 } }, { children: _jsx(CircularProgress, __assign({ "aria-busy": true, color: "inherit" }, props)) })));
}
